/**
 * @author      autogenerated
 * @copyright   Copyright (c) 2025, Zumper
 * @description PropertyFeatures
 */

/**
 * all features are (E)xternal or (I)nternal
 * *** Note ***
 * All enum values MUST also be added to INTERNAL_FEATURES/EXTERNAL_FEATURES and potentially
 * also ASSIGNED_FEATURES in zcode.models.utils.property_features_util
 */
export enum PropertyFeatures {
  /** (E) typically: a building that has an application fee */
  APPLICATION_FEE = 1,
  /** (E) typically: a building that is an assisted living location */
  ASSISTED_LIVING = 2,
  /** (E) typically: a building that has pricing/moving specials */
  SPECIALS = 3,
  /** (E) typically: a building that has some income restricted units */
  INCOME_RESTRICTED = 4,
  /** (E) typically: a building that has some section-8 units */
  SECTION_8 = 5,
  /** (E) typically: a building that has some/all senior living units */
  SENIOR_LIVING = 6,
  /** (E) typically: a building that has some short term stay lease options */
  SHORT_TERM = 7,
  /** (E) typically: a building that supports student housing */
  STUDENT_HOUSING = 8,
  /** @deprecated: (I) deprecated obsolete */
  VIP = 9,
  /** (E) is currently priced according to "sweet deal" criteria */
  SWEET_DEAL = 10,
  /** (I) is a SELECT property */
  SELECT = 11,
  /** (I) subset of SELECT */
  SELECT_MONETIZED = 12,
  /** (I) client paid for promoted pin presentation */
  PAID_PROMOTION = 13,
  /** (I) do not allow detail pages for these properties to be indexed */
  META_NO_INDEX = 14,
  /** @deprecated: (I) deprecated obsolete? */
  REX = 15,
  /** (I) the inventory is exclusive. typically SELECT ? */
  EXCLUSIVE = 16,
  /** (I) exclude from multi-message modal collections */
  MM_EXCLUDE = 17,
  /** (I) supresss multi-message experiences when messing these properties */
  MM_PREVENT = 18,
  /** (I) a direct monetization agreement exists with the supplier */
  DIRECT_DEAL = 19,
  /** (E) floorplans with this feature have units */
  HAS_UNITS = 20,
  /** (I) the listing is enabled for the reserve (book-now) experience */
  BOOK_NOW = 21,
  /** (I) the source of this inventory is non-direct, but monetizing */
  THIRD_PARTY_PAID = 22,
  /** (I) enable large list item cards for a muti-family feature */
  LARGE_LIST_CARD = 23,
  /** (I) require a phone number to be provided */
  REQ_PHONE_NUMBER = 24,
  /** (I) require a move-in date to be provided */
  REQ_MOVE_IN_DATE = 25,
  /** (I) require a custom message to be provided */
  REQ_CUSTOM_MSG = 26,
  /** (I) exclude from facebook resyndication */
  FACEBOOK_EXCLUDE = 27,
  /** (I) Leaselock protection */
  LEASELOCK = 28,
  /** (I) featured listing/building */
  FEATURED = 29,
  /** @deprecated: (I) Allow tour requests (deprecated, all props are tour enabled by default) */
  TOUR = 30,
  /** (E) Utilities included in rent */
  UTILITIES_INCLUDED = 31,
  /** (E) No security or deposit */
  NO_SECURITY_DEPOSIT = 32,
  /** @deprecated: (I) Modified by mm_exclude scripts (associated code for feature deprecated) */
  HIGH_VOLUME = 33,
  /** (E) Supports live virtual/online tours */
  LIVE_VIRTUAL_TOUR = 34,
  /** (E) Has 3d Tour Media (i.e. Matterport) */
  HAS_IFRAME_MEDIA = 35,
  /** (E) Has Video Tour Media (i.e. YouTube) */
  HAS_VIDEO_MEDIA = 36,
  /** (I) Supports programmatic tour scheduling */
  INSTANT_TOUR_SCHEDULING = 37,
  /** (E) show a UTM link based on the homepage and/or source */
  UTM_ENABLED = 38,
  /** (I) deals that include automated posts to 'Google My Business' */
  ZPOST = 39,
  /** (I) property has received zero leads in the past month */
  HIDDEN_GEM = 40,
  /** (I) property is part of signature virtual sales package */
  SIGNATURE_SUBSCRIPTION_PACKAGE = 41,
  /** (I) Rent Guarantee protection */
  RENT_GUARANTEE = 42,
  /** @deprecated: (I) Buildings with too many leads as per the units count (deprecated) */
  HIGH_LEADS_BY_UNITS = 43,
  /** (I) the property provides the instarent service */
  INSTARENT = 44,
  /** (I) whether or not this property is allowed to be shown even when unavailable */
  SHOW_UNAVAILABLE = 45,
  /** (E) the property has no availablability information */
  IS_UNAVAILABLE = 46,
  /** (I) boosted listing/building, also known as "juice" */
  BOOSTED = 47,
  /** (I) disables tour cta */
  TOUR_DISABLED = 48,
  /** (I) The user has paid to post this listing */
  PAY_TO_POST = 52,
  /** (I) indicates listing/building was determined to exceed deal cap and status should be constrained */
  CAPPED_BY_DEAL = 53,
  /** (I) ask pre-qual questions to renters messaging this property */
  PRE_QUAL = 54,
  /** (E) ZirBnB concept */
  LISTING_BOOKING = 55,
  /** (I) identifies property as multifamily paid */
  MULTIFAMILY_PAID = 56,
  /** (I) identifies property as multifamily free */
  MULTIFAMILY_FREE = 57,
  /** (I) instant apply automatic screening+background check */
  INSTANT_APPLY_SCREENING = 58,
  /** (I) instant apply automatic rental application */
  INSTANT_APPLY_APPLICATION = 59,
  /** (I) instant apply screening/application opt out */
  INSTANT_APPLY_MANUAL = 60,
  /** (I) identifies property uses waitlist for zero active units */
  USES_WAITLIST = 61,
  /** (E) property supports short term availability */
  SHORT_TERM_AVAILABILITY = 62,
  /** (I) luxury property */
  LUXURY = 63,
  /** (E) the pricing for this listing is by night */
  NIGHTLY_PRICING = 64,
  /** (I) sends front sms on leads */
  CLIENT_SERVICE_SMS = 65,
  /** (I) newly constructed property */
  NEW_CONSTRUCTION = 66,
  /** (E) free cancellation policy */
  FREE_CANCELLATION = 67,
  /** (I) last feed run showed no price for this prop */
  FEED_NO_PRICE = 68,
  /** (I) indicates listing/building exceeded impression cap */
  IMPRESSION_CAP = 69,
  /** (I) indicates building has associated engrain map object */
  HAS_PROPERTY_MAP = 70,
  /** (E) indicates listing has reviews */
  HAS_REVIEWS = 71,
  /** (I) exclude from digital lead concierge auto lead sending */
  DLC_EXCLUDE = 72,
  /** (I) disable pros/cons data from showing up on property page */
  PROS_CONS_DISABLE = 73,
  /** (I) eligible for digital lead concierge auto lead sending, trumped by dlc_exclude above */
  DLC_BROAD = 74,
  /** (I) Display $0 for fees on frontend (fees include application fees, pet fees, and parking fees) */
  SHOW_0_FOR_FEES = 75,
  /** (I) eligible for expanded (relaxed constraints) digital lead concierge leads, trumped by dlc_exclude */
  DLC_BROAD_PLUS = 76,
  /** (I) property has recently had a "significant" decrease in price */
  PRICE_DROP = 77,
  /** (I) eligible for refined digital lead concierge leads, trumped by dlc_exclude */
  DLC_REFINED = 78,
  /** (E) typically: a building that has some/all military housing units */
  MILITARY_HOUSING = 79,
  /** (E) property explicitly states no breed restrictions for dogs */
  NO_BREED_RESTRICTIONS = 80,
  /** (I) property is part of a spotlight promotion */
  SPOTLIGHT_LISTING = 81,
  /** (I) property is opted out of reengagement */
  SIMILAR_LISTINGS_PREVENT = 82,
  /** (I) property is airbnb friendly */
  AIRBNB_FRIENDLY = 83,
  /** (I) property is freeeemium. */
  FREEMIUM = 84,
  /** (I) eligible for digital lead concierge leads w/even more relaxed similarity constraints than DLC_BROAD_PLUS, trumped by dlc_exclude */
  DLC_BROAD_EXPANDED = 85,
  /** (I) disable external reviews data from showing up on property page */
  EXTERNAL_REVIEWS_DISABLE = 86,
  /** (I) eligible for google business profile Q&A integration */
  GBP_QAS = 87,
  /** (I) AI assistant is enabled for the property */
  AI_ASSISTANT_ENABLED = 88,
  /** (I) property is displayed at zumperrentals.com */
  ZUMPERRENTALS = 89,
  /** (I) property should be rechecked periodically to see if it should be indexed */
  RECHECK_INDEXABILITY = 90,
  /** (I) property has a "good enough" score for eco-living */
  GOOD_FOR_ECO = 91,
  /** (I) property has a "good enough" score for pet-friendliness */
  GOOD_FOR_PETS = 92,
  /** (I) property has a "good enough" score for social life */
  GOOD_FOR_SOCIAL_LIFE = 93,
  /** (I) property has a "good enough" score for wellness */
  GOOD_FOR_WELLNESS = 94,
  /** (I) property has a "good enough" score for work-from-home */
  GOOD_FOR_WFH = 95,
  /** (I) property has 1 or more associated resident_quote rows w/enabled=true */
  HAS_RESIDENT_QUOTES = 96,
  /** (I) property has an associated media object w/media_type=6 (INTERNAL_VIDEO) */
  HAS_HIGHLIGHT_REEL = 97,
}

Object.defineProperty(PropertyFeatures, '__ENUM_NAME', {
  value: 'PropertyFeatures',
  writable: false,
  configurable: false,
  enumerable: false,
})
